<div [kgrLoading]="(state$ | async) === ComponentStates.processing" [kgrLoadingBlocking]="true">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <kgr-form-field
      label="Bestätigungs-Code"
      i18n-label
      [showErrorsIfPristine]="(state$ | async) === ComponentStates.validationError"
      [errors]="(state$ | async) === ComponentStates.validationError ? [invalidCodeError] : []"
    >
      <input type="text" formControlName="token" class="codeInput kgr-input" required autocomplete="one-time-code" />
    </kgr-form-field>
    <div class="kgr-inputGroup">
      <button type="submit" class="kgr-button kgr-button--accent" i18n>überprüfen</button>
    </div>
  </form>
</div>
